/**
 * 聊天快捷台词。属于**游戏内容**，因此放在游戏包里，由 `registry.ts` 注册后交给通用层。
 * 通用层（`apps/web/src/components/ChatPanel.tsx`）只透传，不解释内容 ——
 * 这是 `packages/core/src/types.ts` 里「通用层不为任何具体游戏写特例代码」的直接要求。
 * 文案与旧版 `web/index.html:815-826` 逐条一致（验收项：T6 #10）。
 */
export const FOG_CHESS_CHAT_TAUNTS: readonly string[] = [
    '这步棋，绝了',
    '稳，非常稳',
    '建议重开',
    '我看你是来送人头的',
    '手抖了吧朋友',
    '你这是在下棋还是在抽奖',
    '哭吧，没人看见',
    '菜是原罪',
    '再想想？我等的起',
    '这局我大意了，没有闪',
]
